import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import API_BASE from '../config/api';

const wordmarkStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  paddingTop: '28px',
  textAlign: 'center',
  fontFamily: "'Roboto', sans-serif",
  fontWeight: 900,
  fontSize: '42px',
  letterSpacing: '12px',
  color: '#39FF14',
  textShadow:
    '0 0 6px rgba(57, 255, 20, 0.9), 0 0 12px rgba(57, 255, 20, 0.6), 0 0 20px rgba(57, 255, 20, 0.3)',
  pointerEvents: 'none',
  userSelect: 'none',
};

const pageStyle = {
  minHeight: '100vh',
  backgroundColor: '#222222',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const cardStyle = {
  backgroundColor: '#565656',
  borderRadius: '8px',
  padding: '48px',
  width: '420px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6), 0 0 60px rgba(57, 255, 20, 0.25), 0 0 120px rgba(57, 255, 20, 0.15), 0 0 200px rgba(57, 255, 20, 0.08)',
};

const labelStyle = {
  display: 'block',
  fontFamily: "'Roboto', sans-serif",
  fontWeight: 500,
  fontSize: '14px',
  color: '#F5F5F5',
  marginBottom: '6px',
};

const errorStyle = {
  color: '#BF2634',
  fontFamily: "'Roboto', sans-serif",
  fontWeight: 500,
  fontStyle: 'italic',
  fontSize: '14px',
  backgroundColor: 'rgba(191, 38, 52, 0.1)',
  borderLeft: '3px solid #BF2634',
  padding: '10px 14px',
  borderRadius: '4px',
  marginTop: '12px',
};

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);

  const inputStyle = (focused) => ({
    width: '100%',
    backgroundColor: '#222222',
    border: `1px solid ${focused ? '#39FF14' : '#565656'}`,
    borderRadius: '4px',
    padding: '12px 16px',
    color: '#F5F5F5',
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: '16px',
    marginBottom: '20px',
    outline: 'none',
  });

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/api/auth/login`, { email, password });
      login(res.data.token, res.data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={pageStyle}>
      <div style={wordmarkStyle}>VANCE</div>
      <div style={cardStyle}>
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 700, fontSize: '24px', color: '#FFFFFF', marginBottom: '6px' }}>
            Welcome Back
          </h1>
          <p style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 300, fontSize: '18px', color: '#F5F5F5' }}>
            Sign in to your workspace
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <label style={labelStyle} htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onFocus={() => setEmailFocused(true)}
            onBlur={() => setEmailFocused(false)}
            style={inputStyle(emailFocused)}
            required
          />

          <label style={labelStyle} htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={() => setPasswordFocused(true)}
            onBlur={() => setPasswordFocused(false)}
            style={inputStyle(passwordFocused)}
            required
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              backgroundColor: '#00CC44',
              color: '#FFFFFF',
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 500,
              fontSize: '24px',
              padding: '14px',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              marginTop: '8px',
            }}
            onMouseEnter={(e) => { if (!loading) e.currentTarget.style.backgroundColor = '#009933'; }}
            onMouseLeave={(e) => { if (!loading) e.currentTarget.style.backgroundColor = '#00CC44'; }}
            onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.98)'; }}
            onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          {error && <div style={errorStyle}>{error}</div>}
        </form>

        <div style={{ textAlign: 'center', marginTop: '24px', fontFamily: "'Roboto', sans-serif", fontSize: '14px', color: '#F5F5F5' }}>
          Don't have an account?{' '}
          <span
            onClick={() => navigate('/register')}
            style={{ color: '#39FF14', cursor: 'pointer', textDecoration: 'none' }}
          >
            Create one
          </span>
        </div>
      </div>
    </div>
  );
}
